export const webappPointSubtypes = {
  'webapp.review': 'webapp_review',
  'webapp.survey': 'webapp_survey',
  'webapp.mission': 'webapp_mission',
  'webapp.crm': 'webapp_crm'
} as const

export const webappPointTypes = Object.keys(webappPointSubtypes)

export const isWebappPointType = (type: string): type is keyof typeof webappPointSubtypes =>
  Object.prototype.hasOwnProperty.call(webappPointSubtypes, type)

export const isImportedPointType = (type: string): boolean => type === 'points.imported' || type === 'imported.point'

export const legacyWebappPointSubtypes = [...Object.values(webappPointSubtypes), 'webapp_contest'] as readonly string[]
